import React, { useEffect } from "react";
import {
  Routes,
  Route,
  useNavigate,
  useLocation,
  Navigate,
} from "react-router-dom";
import { Box } from "@mui/material";
import { initializeAnalytics, trackPageView } from "./utils/analytics";
import TopBar from "./components/TopBar";
import Footer from "./components/Footer";
import NordicDashboard from "./components/NordicDashboard/NordicDashboard";
import DetectionTool from "./components/DetectionTool/DetectionTool";
import Home from "./components/Home/Home";
import ResearchTeam from "./components/ResearchTeam";
import PrivacyPolicy from "./components/PrivacyPolicy";
import CookieConsent from "./components/CookieConsent";

function App() {
  const tabs = [
    // { label: "Home", path: "/home" },
    { label: "Nordic Clinical Trials", path: "/nordic-trials-dashboard" },
    { label: "TrialScout", path: "/trialscout" },
    // { label: "Research Team", path: "/research-team" },
  ];

  const location = useLocation();
  const navigate = useNavigate();

  // Initialize analytics and track page views
  useEffect(() => {
    initializeAnalytics();
  }, []);

  useEffect(() => {
    trackPageView(location.pathname);
  }, [location.pathname]);

  const currentTab =
    tabs.find((tab) => location.pathname.startsWith(tab.path)) || tabs[0];

  const handleTabChange = (selectedLabel) => {
    const selectedTab = tabs.find((tab) => tab.label === selectedLabel);
    if (selectedTab) {
      navigate(selectedTab.path);
    }
  };

  return (
    <Box
      sx={{
        display: "flex",
        flexDirection: "column",
        minHeight: "100vh",
      }}
    >
      <TopBar
        handleTabChange={handleTabChange}
        currentTab={currentTab.label}
        tabs={tabs.map((tab) => tab.label)}
      />
      <Box sx={{ flex: 1 }}>
        <Routes>
          <Route
            path="/"
            element={<Navigate to="/nordic-trials-dashboard" replace />}
          />
          <Route path="/home" element={<Home />} />
          <Route
            path="/nordic-trials-dashboard"
            element={<NordicDashboard />}
          />
          <Route path="/trialscout" element={<DetectionTool />} />
          <Route path="/trialscout/:trialId" element={<DetectionTool />} />
          <Route
            path="/detection-tool"
            element={<Navigate to="/trialscout" replace />}
          />
          <Route
            path="/detection-tool/:trialId"
            element={<Navigate to="/trialscout/:trialId" replace />}
          />
          <Route path="/research-team" element={<ResearchTeam />} />
          <Route path="/privacy-policy" element={<PrivacyPolicy />} />
          <Route path="*" element={<NordicDashboard />} />
        </Routes>
      </Box>
      <Footer />
      <CookieConsent />
    </Box>
  );
}

export default App;
